const baseStyle = {};
const defaultProps = {
    size: 'md',
    variant: 'subtleSandstone',
    fontWeight: 'medium'
};
const parts = ['container', 'icon', 'text'];
const sizes = {
    xs: {
        container: {
            borderRadius: 'lg',
            fontSize: 'sm',
            h: 20,
            spaceX: 4
        },
        icon: {
            size: 'xs'
        }
    },
    sm: {
        container: {
            fontSize: 'sm',
            h: 24,
            spaceX: 4
        },
        icon: {
            size: 'xs'
        }
    },
    md: {
        container: {
            fontSize: 'sm',
            h: 32,
            spaceX: 6
        },
        icon: {
            size: 'sm'
        }
    },
    lg: {
        container: {
            fontSize: 'md',
            h: 40,
            spaceX: 8
        },
        icon: {
            size: 'md'
        }
    }
};
const variants = {
    subtleSandstone: {
        container: {
            bg: 'sandstone.90',
            color: 'sandstone.20',
            borderColor: 'transparent'
        }
    },
    subtleEarth: {
        container: {
            bg: 'earth.95',
            color: 'earth.20'
        }
    },
    subtleBlue: {
        container: {
            bg: 'skyBlue.95',
            color: 'seaBlue.main'
        }
    },
    subtleBlue2: {
        container: {
            bg: 'skyBlue.95',
            color: 'skyBlue.20'
        }
    },
    subtleRed: {
        container: {
            bg: 'energyRed.95',
            color: 'energyRed.45'
        }
    },
    subtleYellow: {
        container: {
            bg: 'sunflower.85',
            color: 'sunflower.20'
        }
    },
    subtleGreen: {
        container: {
            bg: 'landGreen.95',
            color: 'landGreen.30'
        }
    },
    /** solids next */
    solidBlue: {
        container: {
            bg: 'skyBlue.65',
            color: 'skyBlue.20'
        }
    },
    solidDarkBlue: {
        container: {
            bg: 'darkBlue.18',
            borderColor: 'darkBlue.18',
            color: 'white'
        }
    },
    solidRed: {
        container: {
            bg: 'energyRed.45',
            color: 'white'
        }
    },
    solidYellow: {
        container: {
            bg: 'sunflower.50',
            color: 'sunflower.15'
        }
    },
    solidGreen: {
        container: {
            bg: 'landGreen.35',
            color: 'white'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
